export class FetchError extends Error {
    constructor(public readonly response: Response) {
        super(response.statusText);
    }
}
